import {ServiceRequestService} from './../../../../back-office/Services/service-request.service';
import {ServiceRequest} from './../../../../back-office/Models/ServiceRequest';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-manage-request-reply',
  templateUrl: './manage-request-reply.component.html',
  styleUrls: ['./manage-request-reply.component.scss']
})
export class ManageRequestReplyComponent implements OnInit, OnDestroy {

  public request: ServiceRequest = new ServiceRequest();
  private subscriptions: Subscription[] = [];
  public solutionIsSelected = false;
  public solutionSteps = [];

  constructor(
    private requestService: ServiceRequestService,
  ) {
  }

  ngOnInit() {

    this.subscriptions.push(
      this.requestService.serviceRequest.subscribe(serviceRequest => {
        this.request = serviceRequest;
        if (this.request.reply) {
          this.solutionIsSelected = true;
          const steps = [];
          for (const replyItem of serviceRequest.reply.replyItems) {
            steps.push(replyItem.solutionStep);
          }
          this.solutionSteps = steps.filter((item) => !item.restricted);
        } else {
          this.solutionIsSelected = false;
          this.solutionSteps = [];
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
